import { DiamondSearchInput } from './overnight/types';
import { Menu } from './shopify/types';

export const essentialMenu: Menu[] = [
  {
    title: 'Diamonds',
    path: '/shop/diamonds/bonded',
  },
  {
    title: 'Engagement Rings',
    path: '/shop/rings',
  },
  {
    title: 'Pendants',
    path: '/shop/pendants',
  },
  {
    title: 'Get Started Kit',
    path: '/shop/service',
  },
  {
    title: 'Loyalty Program',
    path: '/club',
  },
  {
    title: 'Learn more',
    path: '/learn-more',
  },
];

export const menu: Menu[] = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Shop Personalized Diamonds',
    path: '/shop/diamonds/bonded',
  },
  {
    title: 'Shop Lab Grown Diamonds',
    path: '/shop/diamonds/lab',
  },
  {
    title: 'Shop Natural Diamonds',
    path: '/shop/diamonds/natural',
  },
  {
    title: 'Shop Engagement Rings',
    path: '/shop/rings',
  },
  {
    title: 'Shop Pendants',
    path: '/shop/pendants',
  },
  // {
  //   title: 'Custom Jewelry',
  //   path: '/shop/custom'
  // },
  {
    title: 'Shop Jewelry',
    path: '/shop/jewelry',
  },
  {
    title: 'Get Started Kit',
    path: '/shop/service',
  },
  {
    title: 'Loyalty Program',
    path: '/club',
  },
  {
    title: 'Learn more',
    path: '/learn-more',
  },
  {
    title: 'About Us',
    path: '/about',
  },
  {
    title: 'Contact',
    path: '/contact',
  },
];

export type SortFilterItem = {
  title: string;
  slug: string | null;
  sortKey: 'RELEVANCE' | 'BEST_SELLING' | 'CREATED_AT' | 'PRICE';
  reverse: boolean;
};

export const defaultSort: SortFilterItem = {
  title: 'Relevance',
  slug: null,
  sortKey: 'RELEVANCE',
  reverse: false,
};

export const sorting: SortFilterItem[] = [
  defaultSort,
  { title: 'Trending', slug: 'trending-desc', sortKey: 'BEST_SELLING', reverse: false }, // asc
  { title: 'Latest arrivals', slug: 'latest-desc', sortKey: 'CREATED_AT', reverse: true },
  { title: 'Price: Low to high', slug: 'price-asc', sortKey: 'PRICE', reverse: false }, // asc
  { title: 'Price: High to low', slug: 'price-desc', sortKey: 'PRICE', reverse: true },
];

export const TAGS = {
  collections: 'collections',
  products: 'products',
  cart: 'cart',
  customer: 'customer',
};

export const DIAMOND_VARIANT_OPTIONS = ['Color', 'Carat', 'Shape'];

export const DIAMOND_COLOR_OPTIONS = ['White', 'Yellow', 'Pink', 'Blue', 'Green', 'Purple'];

export const SURCHARGE_RATIO_BY_COLOR = {
  White: 0,
  Yellow: 0,
  Pink: 0.2,
  Blue: 0.2,
  Green: 0.2,
  Purple: 0.2,
};

export const DIAMOND_IMAGE_SIZES = [1.9, 2.4, 2.7, 3.0, 3.4, 3.8, 4.3];
export const DIAMOND_RELATIVE_IMAGE_SIZES = [
  (1.9 / 4.3) * 100, // ≈ 44.19%
  (2.4 / 4.3) * 100, // ≈ 55.81%
  (2.7 / 4.3) * 100, // ≈ 62.79%
  (3.0 / 4.3) * 100, // ≈ 69.77%
  (3.4 / 4.3) * 100, // ≈ 79.07%
  (3.8 / 4.3) * 100, // ≈ 88.37%
  100, // 4.3 is 100%
];

const relativeImageSizes = {
  '1/4 ct. +': 7.6,
  '1/2 ct. +': 9.6,
  '3/4 ct. +': 10.8,
  '1 ct. +': 12.0,
  '1 1/2 ct. +': 13.6,
  '2 ct. +': 15.2,
  '3 ct. +': 17.2,
};

export const DISCOUNT_PAY_ONLY_DEPOSIT = 'PAY_ONLY_DEPOSIT';
export const DISCOUNT_PAY_ONLY_REMAINDER = 'PAY_ONLY_REMAINDER';

export const DIAMOND_CUT_SURCHARGE_PRODUCT_HANDLE = 'diamond-cut-surcharge';
export const DIAMOND_COLOR_SURCHARGE_PRODUCT_HANDLE = 'diamond-color-surcharge';
export const PREMIUM_PROCESSING_FEE_PRODUCT_HANDLE = 'premium-processing-fee';
export const CLUB_MEMBERSHIP_PRODUCT_HANDLE = 'bonded-club-membership';
export const SPREAD_4_MONTHS_PLAN_ID = 'gid://shopify/SellingPlan/3663888495';

export const KIT_PRODUCT_TYPE = 'kit';
export const KIT_VARIANT_OPTION = 'plan';
export const KIT_PRODUCT_HANDLE = 'hair-collection-kit';
export const DIAMOND_PRODUCT_TYPE = 'diamond';
export const DIAMOND_PRODUCT_HANDLE = 'diamond';

export const HIDDEN_PRODUCT_TAG = 'nextjs-frontend-hidden';
export const DEFAULT_OPTION = 'Default Title';
export const SHOPIFY_GRAPHQL_API_ENDPOINT = '/api/2024-04/graphql.json';

export const DIAMOND_DUE_RATIO = 0.5;
export const SECOND_DIAMOND_DISCOUNT_RATIO = 0.3;

export const IN_STOCK_DIAMOND_PRODUCT_TYPE = 'In Stock Diamond';

export const JewelryTypeMap = {
  engagement_rings: 'Engagement Rings',
  pendants: 'Pendants',
  // necklaces: 'Necklaces',
  earrings: 'Earrings',
  memorial_items: 'Memorial Items',
};

export const RING_RANKED_SERIES = [
  'Lyon',
  'Cannes',
  'Bordeaux',
  'Roma',
  'Avignon',
  'Vienna',
  'Bruges',
  'Marseille',
  'Milan',
  'Seville',
  'Valencia',
  'Aurora',
  'Zurich',
  'Bruges',
  'Prague',
  'Florence',
  'Versailles',
  'Vienna',
  'Monaco',
  'Edinburgh',
];

export const SITE_NAME = 'Bonded Diamond™';

export const DISCOUNT_CODE_SILVER_CLUB = 'SILVER_MEMBER_ORDER';
export const DISCOUNT_CODE_GOLD_CLUB = 'GOLD_MEMBER_ORDER';
export const DISCOUNT_CODE_PLATINUM_CLUB = 'PLATINUM_MEMBER_ORDER';
export const DISCOUNT_SILVER_CLUB_ID = 'gid://shopify/DiscountCodeNode/1288354267247';
export const DISCOUNT_GOLD_CLUB_ID = 'gid://shopify/DiscountCodeNode/1288360788079';
export const DISCOUNT_PLATINUM_CLUB_ID = 'gid://shopify/DiscountCodeNode/1288360820847';
export const SILVER_CLUB_INFO = {
  tier: 'silver',
  yearlyFee: 0,
  discount: 0.05,
  allowedInvitations: 0,
  discountCode: DISCOUNT_CODE_SILVER_CLUB,
};

export const GOLD_CLUB_INFO = {
  tier: 'gold',
  yearlyFee: 300,
  discount: 0.1,
  allowedInvitations: 2,
  discountCode: DISCOUNT_CODE_GOLD_CLUB,
};

export const PLATINUM_CLUB_INFO = {
  tier: 'platinum',
  yearlyFee: 600,
  discount: 0.15,
  allowedInvitations: 5,
  discountCode: DISCOUNT_CODE_PLATINUM_CLUB,
};

export const CLUB_INFOS = [SILVER_CLUB_INFO, GOLD_CLUB_INFO, PLATINUM_CLUB_INFO];

export const CUSTOMER_MENU = [
  { name: 'My Profile', href: '/customer' },
  { name: 'Account Settings', href: '/customer/profile' },
  { name: 'Order History', href: '/customer/order' },
  { name: 'Membership & Discounts', href: '/customer/membership' },
  { name: 'Support', href: '/customer/support' },
];

export const CHECKOUT_CART_COOKIE_NAME = 'cartId';
export const QUOTE_CART_COOKIE_NAME = 'quoteCartId';

export const CART_ATTRIBUTE_JEWELRY_LINE_KEY = 'jewelryLineId';
export const CART_ATTRIBUTE_DIAMOND_LINE_KEY = 'diamondLineId';
export const ORDER_TYPE_ATTRIBUTE_KEY = 'order-type';
export const SAVED_QUOTE_CART_ATTRIBUTE_KEY = 'saved-quote-cart';
export const SERVICE_ORDER_NUMBER_ATTRIBUTE_KEY = 'service-order-number';
export const ORDER_TYPE_SERVICE = 'service';
export const ORDER_TYPE_CONFIRMATION = 'confirmation';
export const ORDER_TYPE_PAYMENT = 'payment';

export const SUPPORTED_SHAPES = [
  'Round',
  'Emerald',
  'Cushion',
  'Princess',
  'Pear',
  'Oval',
  'Marquise',
  'Heart',
  'Radiant',
  'Asscher',
];
export const SHAPE_SAMPLE_WEIGHTS = [8, 3, 1, 3, 2, 3, 4, 2, 4, 1];
export const METAL_OPTION_NAME = 'Precious Metal';
export const DIAMOND_WEIGHT_OPTION_NAME = 'Diamond Weight';
export const SUPPORTED_WEIGHTS = ['1/4 ct', '1/2 ct', '3/4 ct', '1 ct', '1 1/2 ct', '2 ct', '3 ct'];

export const CLARITY_OPTIONS = ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL'];
export const CLARITY_SAMPLE_WEIGHTS = [1, 1, 2, 2, 4, 4, 2, 2];
export const CUT_OPTIONS = ['Fair', 'Good', 'Very Good', 'Excellent', 'Ideal'];
export const CUT_SAMPLE_WEIGHTS = [1, 1, 2, 4, 4];
export const COLOR_OPTIONS = ['J', 'I', 'H', 'G', 'F', 'E', 'D'];
export const COLOR_SAMPLE_WEIGHTS = [1, 1, 4, 4, 8, 8, 8];
export const CARAT_OPTIONS = [0.25, 0.5, 0.75, 1, 2, 3];
export const CARAT_SAMPLE_WEIGHTS = [1, 2, 2, 4, 4, 2];
export const CARAT_DISPLAY_OPTIONS = [
  '1/4 ct. +',
  // 'Almost 1/2 ct.',
  '1/2 ct. +',
  // 'Almost 3/4 ct.',
  '3/4 ct. +',
  // 'Almost 1 ct.',
  '1 ct. +',
  // 'Almost 2 ct.',
  '2 ct. +',
  // 'Almost 3 ct.',
  '3 ct. +',
];
export const PRICE_VALUES = [200, 500, 1000, 2000, 5000, 10000];

// export const LAB_DIAMOND_IMAGE_SIZES = [
//   1.9, 2.3, 2.4, 2.6, 2.7, 2.9, 3.0, 3.3, 3.4, 3.7, 3.8, 4.2, 4.3
// ];

export const CATEGORY_ID_GEMSTONE = 'gid://shopify/TaxonomyCategory/ae-2-2-6-2';

export const DEFAULT_DIAMOND_SEARCH_INPUT: DiamondSearchInput = {
  shape: 'Round',
  priceMin: undefined,
  priceMax: undefined,
  caratMin: 1,
  caratMax: undefined,
  clarityMin: 'VS1',
  clarityMax: 'FL',
  cutMin: 'Very Good',
  cutMax: 'Ideal',
  colorMin: 'G',
  colorMax: 'D',
  page: 1,
};
